import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

// Editorial FAQ accordion. tone: "dark" | "light"
const FaqAccordion = ({ items, tone = "dark", testid = "faq-accordion" }) => {
  const ink = tone === "dark" ? "text-[#F4F0E8]" : "text-[#171717]";
  const sub = tone === "dark" ? "text-[#F4F0E8]/65" : "text-[#171717]/70";
  const border = tone === "dark" ? "border-[#F4F0E8]/12" : "border-[#171717]/12";

  return (
    <Accordion type="single" collapsible className="w-full" data-testid={testid}>
      {items.map((item, i) => (
        <AccordionItem key={i} value={`item-${i}`} className={`border-b ${border}`}>
          <AccordionTrigger
            data-testid={`${testid}-q-${i}`}
            className={`py-6 text-left text-base font-light tracking-tight hover:no-underline ${ink} [&[data-state=open]]:text-[#C6A46A]`}
          >
            <span className="flex items-baseline gap-4">
              <span className="text-[0.6rem] font-medium tracking-[0.18em] text-[#C6A46A]">
                {String(i + 1).padStart(2, "0")}
              </span>
              {item.q}
            </span>
          </AccordionTrigger>
          <AccordionContent className={`pb-6 pl-10 pr-4 text-sm leading-relaxed ${sub}`}>
            {item.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default FaqAccordion;
